import {ReactElement} from 'react';
import {Grid, Typography, TypographyProps} from '@mui/material';

interface LabelValueProps extends TypographyProps {
  align: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  variant:
    | 'body1'
    | 'body2'
    | 'button'
    | 'caption'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'inherit'
    | 'overline'
    | 'subtitle1'
    | 'subtitle2';

  label: any;
  value: any;
  alignItems?: string;
  direction?: any;
  spacing?: number;
  labelColor?: string;
  valueColor?: string;
  labelStyle?: any;
  valueStyle?: any;
  marginLeft?: any;
  columnRequired?: boolean;
  justifyContent?: string;
  labelWidth?: any;
  valueWidth?: any;
}

const LabelValueInput = (props: LabelValueProps): ReactElement => {
  const {
    variant,
    align,
    label,
    value,
    alignItems,
    direction,
    spacing,
    labelColor,
    valueColor,
    style,
    marginLeft,
    columnRequired,
    justifyContent,
    labelWidth,
    valueWidth,
    ...rest
  } = props;

  return (
    <Grid
      container
      spacing={spacing}
      alignItems={alignItems}
      justifyContent={justifyContent}
      direction={direction}>
      <Grid item width={labelWidth}>
        <Typography
          {...rest}
          variant={variant}
          align={align}
          color={labelColor}
          style={style}>
          {label && `${label} ${columnRequired ? ': ' : ''}`}
        </Typography>
      </Grid>
      <Grid item sx={{marginLeft: {marginLeft}}} width={valueWidth}>
        <Typography
          {...rest}
          variant={variant}
          align={align}
          color={valueColor}>
          {value}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default LabelValueInput;
